import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import type { AddressForm } from '@/shared/utils/areaPicker/types';
import type { InfoComplementField } from '../../types';

import styles from './index.module.scss';

@Component({ name: 'LiveAddress' })
export default class LiveAddress extends Vue implements InfoComplementField {
  @Prop()
  private value!: AddressForm;

  /**
   * 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
   */
  @Prop()
  private validator: (
    (value: AddressForm | null, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private liveAddress: AddressForm | null = null;

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  private created() {
    if (this.value) {
      this.liveAddress = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: AddressForm) {
    if (val !== this.liveAddress) {
      this.liveAddress = val;
    }
  }

  public onValidator(): boolean {
    const val = this.liveAddress;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }

    if (this.liveAddress === null) {
      this.setErrorMsg('请选择省市区');
      return false;
    }

    return true;
  }

  private onChangeAddress(val: AddressForm | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={styles.liveAddress}>
        <Field
          v-model={this.liveAddress}
          onChange={() => this.onChangeAddress(this.liveAddress)}
          sub={true}
          label="居住地"
          type="address"
          error={this.errorMsg}
        />
      </div>
    );
  }
}
